import { Modal } from 'antd'
import Countdown from '../CountDown'
import { useEffect, useState } from 'react'
import { ReactComponent as ExpiredWarningIcon } from '../../../../assets/icons/expired-warning.svg'
import { copyToClipboard } from '../../../../helper/common'
import { CopyOutlined } from '@ant-design/icons'
import './index.scss'
import PaymentService from '../../../../services/paymentService'
import { HOST } from '../../../../constants/url'
import BaseButton from '../../../../components/BasicComponent/BaseButton'
import SafeImage from '../../../../components/BasicComponent/SafeImage'

const ModalPaymentQR = ({ open, onClose, driver, onRefresh, method }) => {
  const [base64, setBase64] = useState(null)
  const { formatedTotalPay, expiredInMinutes, runTime } = driver

  const [paymentMethod, setPaymentMethod] = useState({})
  const [loading, setLoading] = useState(true)
  const [expiredText, setExpiredText] = useState('Mã QR hết hiệu lực sau')

  useEffect(() => {
    ;(async () => {
      try {
        setLoading(true)
        const data = await PaymentService.getPaymentQRMethod({})
        const dataConverted = Object.fromEntries(Object.values(data || {}).map((item) => [item.paymentMethodId, item]))
        setPaymentMethod(dataConverted)
      } catch {
        setPaymentMethod({})
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  const onRf = () => {
    setExpiredText('Mã QR hết hiệu lực sau')
    onRefresh()
  }

  const dataQR = (() => {
    if (loading || !method) return {}
    return method === 'momo' ? driver?.qr?.momoQR : driver?.qr?.bankQR
  })()
  const convertToBase64 = async (url) => {
    try {
      const response = await fetch(url)
      const blob = await response.blob() // Lấy blob từ response

      const reader = new FileReader()
      reader.onloadend = () => {
        setBase64(reader.result) // Set kết quả base64 vào state
      }
      reader.readAsDataURL(blob) // Đọc blob dưới dạng base64
    } catch (error) {}
  }
  const qrUrl = (() => {
    if (method === 'momo') {
      if (dataQR?.qrDataURL) {
        if (dataQR?.qrDataURL?.includes('base64')) {
          return dataQR?.qrDataURL
        } else {
          convertToBase64(`${HOST}/${dataQR?.qrDataURL}`)
          return ''
        }
      } else {
        return dataQR?.qrDataURL
      }
    }

    if (dataQR?.qrData?.includes('base64')) {
      return dataQR?.qrData
    }

    return `${HOST}/${dataQR?.qrData}`
  })()
  return (
    <>
      <Modal title="" open={open} centered footer={null} closable={false} className="modal-payment-qr text-center py-3" onClose={onClose}>
        {loading || !method ? (
          <div className="modal-payment-qr-loading">
            <SafeImage src="/logo.png" />
            <span style={{ fontSize: '16px', lineHeight: '1.5', fontWeight: 700, color: 'var(--text-primary)' }}>Đang tải dữ liệu...</span>
          </div>
        ) : (
          <div className="d-flex flex-column gap-1">
            <div className="modal-payment-qr-header mb-3">
              <h5 className="font-weight-600">Thanh toán</h5>
              <span>Chuyển khoản hoặc quét mã QR để thanh toán qua tất cả Ví và Ngân hàng</span>
            </div>

            <div className="modal-payment-qr-content d-flex align-items-center flex-column px-3 py-3 bg-white">
              <div>
                {paymentMethod[method]?.paymentMethodImageUrl && (
                  <SafeImage src={paymentMethod[method]?.paymentMethodImageUrl} width={186} />
                )}
              </div>
              <div className="w-100 d-flex flex-column gap-3 mt-4">
                <div className="d-flex align-items-start justify-content-between gap-1">
                  <span className="modal-payment-qr-content-title">Tên tài khoản</span>
                  <span className="word-break-all text-left w-100">
                    <b>{paymentMethod[method]?.paymentMethodReceiverName}</b>
                  </span>
                </div>
                <div className="d-flex align-items-start justify-content-between gap-1">
                  <span className="modal-payment-qr-content-title">Số tài khoản</span>

                  <div className="d-flex align-items-start gap-2 w-100">
                    <span className="word-break-all text-left">
                      <b>{paymentMethod[method]?.paymentMethodIdentityNumber}</b>
                    </span>
                    <CopyOutlined onClick={() => copyToClipboard(paymentMethod[method]?.paymentMethodIdentityNumber)} />
                  </div>
                </div>
                <div className="d-flex align-items-start justify-content-between gap-1">
                  <span className="modal-payment-qr-content-title">Số tiền</span>
                  <div className="d-flex align-items-start gap-2 w-100">
                    <span className="word-break-all text_primary text-left">
                      <b>{formatedTotalPay}đ</b>
                    </span>
                    <CopyOutlined onClick={() => copyToClipboard(formatedTotalPay)} />
                  </div>
                </div>
                <div className="d-flex align-items-start justify-content-between gap-1">
                  <span className="modal-payment-qr-content-title">Nội dung</span>

                  <div className="d-flex align-items-start gap-2 w-100">
                    <div className="text-left w-100">
                      <div className="word-break-all text_primary text-left mobile-wrap">
                        <b>{dataQR?.paymentContent}</b>
                      </div>
                      <div className="text_warning">Vui lòng ghi đúng nội dung chuyển khoản</div>
                    </div>
                    <CopyOutlined onClick={() => copyToClipboard(dataQR?.paymentContent)} />
                  </div>
                </div>
              </div>

              <div className="hr"></div>

              <div className="modal-payment-qr-footer d-flex align-items-center gap-1 justify-content-center mb-2">
                <ExpiredWarningIcon />
                &nbsp;
                <span className="">{expiredText}</span>
                <span className={`modal-payment-qr-expired-in-countdown`}>
                  <Countdown
                    formater={(time) => {
                      const minutes = Math.floor(time / 60)
                      const seconds = time % 60
                      const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

                      return formattedTime
                    }}
                    seconds={expiredInMinutes * 60}
                    event={() => {}}
                    onEnd={() => {
                      setExpiredText('Mã QR hết hiệu lực.')
                      return (
                        <span onClick={onRf} style={{ color: 'var(--brand-primary)', cursor: 'pointer', fontWeight: 600 }}>
                          Làm mới
                        </span>
                      )
                    }}
                    key={runTime}
                  />
                </span>
              </div>
              <div className="modal-payment-qr-img">
                <SafeImage src={qrUrl || base64} width={186} height={186} />
              </div>
              <div className="mt-2">
                <a download={'qrcode.png'} href={qrUrl || base64} target="_blank" rel="noreferrer" className="download-qr py-1 px-3 text_primary">
                  Tải ảnh QR
                </a>
              </div>
            </div>

            <div className="mt-4">
              <BaseButton onClick={onClose}>Đóng</BaseButton>
            </div>
          </div>
        )}
      </Modal>
    </>
  )
}

export default ModalPaymentQR
